




















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import SpinnerIcon from '~/components/common/BravadoButtonV3/images/spinner.vue.svg';

type BravadoButtonV3Type = 'a' | 'button' | 'NuxtLink';
type BravadoButtonV3Variant = 'accent' | 'primary' | 'secondary' | 'danger' | 'blank' | 'border';

export enum BravadoButtonV3Size {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

@Component<BravadoButtonV3>({
  name: 'BravadoButtonV3',
  components: { SpinnerIcon },
})
export default class BravadoButtonV3 extends Vue {
  @Prop({ default: 'md', type: String }) readonly size?: BravadoButtonV3Size;
  @Prop({ default: 'accent', type: String }) readonly variant?: BravadoButtonV3Variant;
  @Prop({ default: false, type: Boolean }) readonly isIconButton?: boolean;
  @Prop({ default: false, type: Boolean }) readonly isSoftDisabled?: boolean;
  @Prop({ default: false, type: Boolean }) readonly elevated?: boolean;
  @Prop({ default: false, type: Boolean }) readonly loading?: boolean;
  @Prop({ default: false, type: Boolean }) readonly fullWidth?: boolean;

  get componentType(): BravadoButtonV3Type {
    const { href, to, disabled } = this.$attrs;

    if (href && !disabled) return 'a';

    return to && !disabled ? 'NuxtLink' : 'button';
  }

  get rootClass(): Record<string, boolean> {
    return {
      'bravado-button-v3': true,
      [`bravado-button-v3--${this.size}`]: true,
      [`bravado-button-v3--${this.variant}`]: true,
      'bravado-button-v3--icon': this.isIconButton as boolean,
      'bravado-button-v3--soft-disabled': this.isSoftDisabled as boolean,
      'bravado-button-v3--elevated': this.elevated as boolean,
      'bravado-button-v3--loading': this.loading as boolean,
      'bravado-button-v3--full-width': this.fullWidth as boolean,
    };
  }

  get iconSize(): number {
    if (this.size === BravadoButtonV3Size.xs) return 16;
    else if (this.size === BravadoButtonV3Size.sm) return 20;
    else return 24;
  }
}
